<template>
<img :src="src" :alt="alt" :class="className">
</template>

<script>
export default {
  props: {
    alt: String,
    className: String
  },
  data () {
    return {
      src: String
    }
  }
}
</script>

<style lang="scss" scoped>
.c-img {
  width: 100%;

  &__adjust{
    width: 100%;
    height: 100%;
  }
  &__pos00{
    @extend .c-img;
    transform: translateZ(292/1280*100vw) scale(0.7);
    position: absolute;
    top: 0;
    left: 0;

    &--scale{
      @extend .c-img__pos00;
      transform: translateZ(492/1280*100vw) scale(0.7);
    }
  }
}
</style>
